import React from 'react';
import { Alert, Typography } from '@one-thd/sui-atomic-components';

const ErrorBanner = () => {
  return (
    <div className="sui-mb-4" data-testid="error-banner">
      <Alert status="error" size="large">
        <Typography variant="body-base">
          We’re sorry. There was a temporary technical error. Please try again
          shortly or call 1-866-333-3551 for assistance.
        </Typography>
      </Alert>
    </div>
  );
};

export default ErrorBanner;
